var $37ef4527b8b05b49$exports = {};
$37ef4527b8b05b49$exports = {
    "(optional)": `(nepovinn\xe9)`,
    "(required)": `(povinn\xe9)`
};


export {$37ef4527b8b05b49$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
